import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {UserManagementService} from '../../../../../shared/_services/user-management.service';
import {ValidationService} from '../../../../../shared/_services/validation.service';

@Component({
  selector: 'app-user-management-details',
  templateUrl: './user-management-details.component.html',
  styleUrls: ['./user-management-details.component.scss']
})
export class UserManagementDetailsComponent implements OnInit {
  user: FormGroup;
  userId: number;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private validationService: ValidationService,
    private userManagementService: UserManagementService
  ) {
  }

  ngOnInit() {
    console.log('==== component loaded ====');
    this.route.params.subscribe(params => {
      this.userId = +params['id']; // (+) converts string 'id' to a number
    });
    this.getUserInfo(this.userId);
    this.user = this.fb.group({
      email: [''],
      firstName: ['', Validators.required],
      lastName1: ['', Validators.required],
      mobileNumber: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(15)])],
      password: [''],
      newPassword: ['']
    });
  }

  getUserInfo(userId) {
    this.userManagementService.getProfile(userId).subscribe(
      data => {
        if (data.error === 0) {
          console.log(data);
          this.user.patchValue(data.responseObj);
        }
      }, error => {
        console.error(error);
      }
    );
  }

  saveUserInfo(data) {
    data.value.loyaltyUserId = this.userId;
    const formData: any = new FormData();
    formData.append('user', JSON.stringify(data.value));
    console.log(data.value);
    const file = new Blob([], {type: 'image/jpg'});
    formData.append('profilePic', file, null);
    this.userManagementService.profileUpdate(formData, false).subscribe((res) => {
      console.log('========res ===========', res);
      this.router.navigate(['/user-management']).then();
    }, error => {
      console.log('========res ===========', error);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/user-management/user-management-details/user-management-details.component.ts